"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMockUser = exports.actionedByUser = void 0;
const enums_1 = require("../../../contracts/enums");
const constants_1 = require("../../../constants");
exports.actionedByUser = {
    familyName: "Jones",
    firstName: "Amy",
    secondName: "Cavandish",
    thirdName: "Mary",
    userId: "users-default",
};
const getMockUser = ({ _id = "users-default", salutation = "Ms", firstName = "Amy", familyName = "Jones", secondName = "Cavandish", thirdName = "Mary", emails = [
    {
        email: "testUser@example.com",
        isPrimary: true,
        isVerified: true,
        verificationToken: "",
    },
], phones = [
    {
        iso2: "UA",
        dialCode: "+380",
        phoneNumber: "0952061973",
        isPrimary: true,
        isVerified: true,
    },
], birthDetails = {
    dob: new Date(1985, 10, 21),
    birthCountry: "Australia",
    birthPlace: "Sydney",
}, addressId = "", address = {
    careOf: "",
    line2: "Unit 3",
    street: "Main St",
    locality: "Sydney",
    postcode: "2000",
    state: "NSW",
    country: "Australia",
}, tfn = "123456789", username = "NF901445", kycDetails = {
    isKYCDone: true,
    address: {
        description: "Beale House",
        flatNumber: "29",
        streetNumber: "311",
        streetName: "George St",
        suburb: "Sydney",
        postcode: "2000",
        state: "NSW",
        country: "AU",
    },
    verificationId: "8ivfuML7",
    verificationToken: "4ea203de8488598a7c5f71e3a738203493c51ea4",
}, companyIds = ["companies-1"], onboardingStatus = enums_1.CompanyListItemStatus.Active, isInvestor = true, shareholdings = [], roles = [constants_1.Roles.ADMIN], rolesByCompany = [
    {
        companyId: "companies-1",
        roles: [constants_1.Roles.ADMIN],
    },
], nomineeCompanies = [], lastLogin = new Date(), } = {}) => ({
    _id,
    salutation,
    firstName,
    familyName,
    secondName,
    thirdName,
    emails,
    phones,
    birthDetails,
    addressId,
    address,
    tfn,
    username,
    kycDetails,
    companyIds,
    onboardingStatus,
    isInvestor,
    shareholdings,
    roles,
    rolesByCompany,
    nomineeCompanies,
    lastLogin,
});
exports.getMockUser = getMockUser;
//# sourceMappingURL=user.mock.js.map